import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import RateReviewIcon from '@mui/icons-material/RateReview';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import StoreIcon from '@mui/icons-material/Store';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

export const getBusinessItems = (handleNavigation, API_ENDPOINTS) => [
    {
        label: 'Add new business',
        to: API_ENDPOINTS.VENDOR.BUSINESS_NEW,
        icon: <AddBusinessIcon />,
        onClick: handleNavigation(API_ENDPOINTS.VENDOR.BUSINESS_NEW)
    },
    {
        label: 'Business sign in',
        to: API_ENDPOINTS.VENDOR.HOME,
        icon: <LoginIcon />,
        onClick: handleNavigation(API_ENDPOINTS.VENDOR.HOME)
    },
];

export const getSignedInBusinessItems = (handleNavigation, API_ENDPOINTS, restaurantId) => [
    {
        label: 'Go to restaurant',
        to: `/restaurant/${restaurantId}`,
        icon: <StoreIcon />,
        onClick: handleNavigation(`/restaurant/${restaurantId}`)
    },
    {
        label: 'Go to vendor dashboard',
        to: API_ENDPOINTS.VENDOR.HOME,
        icon: <ExitToAppIcon />,
        onClick: handleNavigation(API_ENDPOINTS.VENDOR.HOME)
    },
];

export const getProfileItems = (handleNavigation, API_ENDPOINTS) => [
    {
        label: 'Profile',
        to: API_ENDPOINTS.AUTH.PROFILE,
        icon: <PersonIcon />,
        onClick: handleNavigation(API_ENDPOINTS.AUTH.PROFILE)
    },
    {
        label: 'Orders',
        to: '/profile/orders',
        icon: <ReceiptLongIcon />,
        onClick: handleNavigation('/profile/orders')
    },
    {
        label: 'Reviews',
        to: '/profile/reviews',
        icon: <RateReviewIcon />,
        onClick: handleNavigation('/profile/reviews')
    },
    {
        label: 'Favourites',
        to: '/profile/favourites',
        icon: <FavoriteIcon />,
        onClick: handleNavigation('/profile/favourites')
    },
    {
        label: 'Settings',
        to: API_ENDPOINTS.AUTH.SETTINGS,
        icon: <SettingsIcon />,
        onClick: handleNavigation(API_ENDPOINTS.AUTH.SETTINGS)
    },
];

export const getAuthenticatedDrawerItems = ({
    businessExpanded,
    handleBusinessToggle,
    businessItems,
    profileExpanded,
    handleProfileToggle,
    profileItems,
    themeMode,
    handleThemeToggle,
    handleSignOut
}) => [
        {
            label: 'Business',
            icon: <StoreIcon />,
            isCollapsible: true,
            expanded: businessExpanded,
            onToggle: handleBusinessToggle,
            subItems: businessItems
        },
        {
            label: 'Account',
            icon: <ManageAccountsIcon />,
            isCollapsible: true,
            expanded: profileExpanded,
            onToggle: handleProfileToggle,
            subItems: profileItems
        },
        {
            label: 'Dark mode',
            icon: <DarkModeIcon />,
            isSwitch: true,
            checked: themeMode === 'dark',
            onClick: handleThemeToggle
        },
        {
            label: 'Sign out',
            icon: <LogoutIcon />,
            onClick: handleSignOut,
            divider: true
        },
    ];

export const getUnauthenticatedDrawerItems = ({
    businessExpanded,
    handleBusinessToggle,
    businessItems,
    themeMode,
    handleThemeToggle
}) => [
        {
            label: 'Business',
            icon: <StoreIcon />,
            isCollapsible: true,
            expanded: businessExpanded,
            onToggle: handleBusinessToggle,
            subItems: businessItems
        },
        {
            label: 'Dark mode',
            icon: <DarkModeIcon />,
            isSwitch: true,
            checked: themeMode === 'dark',
            onClick: handleThemeToggle
        }
    ];
